type WindowWithXRFrame = Window & typeof globalThis & {
  XRFrame?: {
    prototype?: XRFrame & {
      __artetraDetectedPlanesGuarded?: boolean;
    };
  };
};

const INVALID_STATE_ERROR = "InvalidStateError";

const isInvalidXRFrameAccess = (error: unknown) => (
  Boolean(error)
  && typeof error === "object"
  && "name" in error
  && (error as { name?: string }).name === INVALID_STATE_ERROR
);

export const installXRFrameDetectedPlanesGuard = (targetWindow: WindowWithXRFrame = window as WindowWithXRFrame) => {
  const xrFramePrototype = targetWindow.XRFrame?.prototype;
  if (!xrFramePrototype || xrFramePrototype.__artetraDetectedPlanesGuarded) {
    return false;
  }

  const descriptor = Object.getOwnPropertyDescriptor(xrFramePrototype, "detectedPlanes");
  if (!descriptor?.get) {
    return false;
  }

  try {
    Object.defineProperty(xrFramePrototype, "detectedPlanes", {
      configurable: descriptor.configurable,
      enumerable: descriptor.enumerable,
      get() {
        try {
          return descriptor.get?.call(this);
        } catch (error) {
          if (isInvalidXRFrameAccess(error)) {
            return undefined;
          }
          throw error;
        }
      },
    });

    Object.defineProperty(xrFramePrototype, "__artetraDetectedPlanesGuarded", {
      configurable: true,
      value: true,
    });
    return true;
  } catch (error) {
    console.warn("WebXR detectedPlanes guard could not be installed", error);
    return false;
  }
};
